import { render, staticRenderFns } from "./OriginalConfig.vue?vue&type=template&id=8cd67010"
import script from "./OriginalConfig.vue?vue&type=script&lang=js"
export * from "./OriginalConfig.vue?vue&type=script&lang=js"
import style0 from "./OriginalConfig.vue?vue&type=style&index=0&id=8cd67010&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports